import product1 from "./assets/product1.png";
import product2 from "./assets/product2.png";
import product3 from "./assets/product3.png";
import product4 from "./assets/product4.png";
import product5 from "./assets/product5.png";
import product6 from "./assets/product6.png";
import product7 from "./assets/product7.png";
import product8 from "./assets/product8.png";
import product9 from "./assets/product9.png";

export const PRODUCTS = [
  {
    id: 1,
    productName: "Cell Phone",
    price: 999.0,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Laptop",
    price: 2999.0,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Camera",
    price: 845.0,
    productImage: product3,
  },
  {
    id: 4,
    productName: "External Hard Drive",
    price: 299.0,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Monitor",
    price: 1999.0,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Tablet",
    price: 799.0,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Head Phones",
    price: 599.0,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Mouse",
    price: 59.0,
    productImage: product8,
  },
  {
    id: 9,
    productName: "Keyboard",
    price: 149.0,
    productImage: product9,
  },
];
